import { generateArticles as defaultArticles } from "./contract/defaultArticles";
import { generateArticlesClubCityes } from "./contract/clubcityes";
import { generateArticlesZoneFightGym } from "./contract/zonefightgym";
import { generateArticlesOneFit } from "./contract/onefit";
import { generateArticlesLadysharmony } from "./contract/ladysharmony";
import { generateArticlesEnergyPlus } from "./contract/energyplus";
import { generateArticlesCapforme } from "./contract/capforme";

export const contractsRegistry: Record<string, Function> = {
  default: defaultArticles,
  clubcityes: generateArticlesClubCityes,
  zonefightgym: generateArticlesZoneFightGym,
  onefit: generateArticlesOneFit,
  ladysharmony: generateArticlesLadysharmony,
  capforme: generateArticlesCapforme,
  energyplus: generateArticlesEnergyPlus,
};
